import index from './action/index'

export default {
  index,
}
